var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_138",
    "data-name": "Rectangle 138",
    width: 27,
    height: 27,
    transform: "translate(298.555 963.903)",
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "calendar",
    transform: "translate(-298.555 -963.903)",
    opacity: 0.902,
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_249",
    "data-name": "Group 249"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_248",
    "data-name": "Group 248",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_247",
    "data-name": "Group 247"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_246",
    "data-name": "Group 246",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M300.716,975.089v-3.261h21.73v3.261Zm21.771,13.047H300.716V977.25h21.73v10.886Zm.53-18.51H312.7V968.24a2.129,2.129,0,0,0,1.1-1.835,2.245,2.245,0,0,0-2.2-2.2,2.175,2.175,0,0,0-2.161,2.16,2.08,2.08,0,0,0,1.1,1.835v1.427H300.186a1.609,1.609,0,0,0-1.631,1.631v17.409a1.691,1.691,0,0,0,1.631,1.631h22.831a1.692,1.692,0,0,0,1.631-1.631V971.3A1.7,1.7,0,0,0,323.017,969.626Z",
    fill: "#6c5b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M304.548,981.612h1.1a.492.492,0,0,0,.53-.53v-1.1a.493.493,0,0,0-.53-.53h-1.1a.493.493,0,0,0-.53.53v1.1A.491.491,0,0,0,304.548,981.612Z",
    fill: "#6c5b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M308.87,981.612h1.1a.492.492,0,0,0,.53-.53v-1.1a.492.492,0,0,0-.53-.53h-1.1a.492.492,0,0,0-.53.53v1.1A.513.513,0,0,0,308.87,981.612Z",
    fill: "#6c5b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M313.232,981.612h1.1a.492.492,0,0,0,.53-.53v-1.1a.493.493,0,0,0-.53-.53h-1.1a.493.493,0,0,0-.53.53v1.1A.514.514,0,0,0,313.232,981.612Z",
    fill: "#6c5b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M317.6,981.612h1.1a.492.492,0,0,0,.53-.53v-1.1a.493.493,0,0,0-.53-.53h-1.1a.493.493,0,0,0-.531.53v1.1A.492.492,0,0,0,317.6,981.612Z",
    fill: "#6c5b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M304.548,985.934h1.1a.493.493,0,0,0,.53-.53v-1.1a.493.493,0,0,0-.53-.53h-1.1a.493.493,0,0,0-.53.53v1.1C303.977,985.73,304.222,985.934,304.548,985.934Z",
    fill: "#6c5b7b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_135",
    "data-name": "Rectangle 135",
    width: 2.161,
    height: 2.161,
    rx: 0.53,
    transform: "translate(308.34 983.773)",
    fill: "#6c5b7b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_136",
    "data-name": "Rectangle 136",
    width: 2.161,
    height: 2.161,
    rx: 0.53,
    transform: "translate(312.702 983.773)",
    fill: "#6c5b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M317.6,985.934h1.1a.493.493,0,0,0,.53-.53v-1.1a.493.493,0,0,0-.53-.53h-1.1a.493.493,0,0,0-.531.53v1.1C317.024,985.73,317.268,985.934,317.6,985.934Z",
    fill: "#6c5b7b"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.de10f266ea05e79633c7ca9eb5d6b7ce.svg";
export { ForwardRef as ReactComponent };